var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.924 1.617l.038.11L18.735 8 23 8a1 1 0 01.995 1.103l-.02.117-2.933 13a1 1 0 01-.976.78H3.933a1 1 0 01-.975-.78l-2.933-13A1 1 0 011 8h4.264l1.774-6.272a1 1 0 011.95.43l-.026.114-1.619 5.727h9.313l-1.618-5.727a1 1 0 011.886-.655zM21.748 10H2.25l2.482 11h14.534l2.482-11z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconBasket;